"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParams = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _form = _interopRequireDefault(require("./form.js"));
var _randomstring = _interopRequireDefault(require("randomstring"));
var _admin = require("../../../reducers/admin.js");
var _reactRedux = require("react-redux");
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
var _moment = _interopRequireDefault(require("moment"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd.boilerplate;
var getParams = exports.getParams = function getParams(values) {
  var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type;
  var roleHandle;
  switch (values.respondentConfig) {
    case 'manual':
      type = 'known';
      roleHandle = 'respondent';
      break;
    case 'anonymous':
      type = 'anon';
      roleHandle = 'respondent';
      break;
    case 'managed':
      type = 'group';
      roleHandle = values.respondentSelection;
      break;
    case 'previous':
      // check what the previous dcw is
      type = 'known'; // or whatever it is
      roleHandle = 'respondent';
      break;
    default:
  }
  var opensAt = values.opensOn ? (0, _moment["default"])(values.opensOn).utc().toString() : '';
  var closesAt = values.closesOn ? (0, _moment["default"])(values.closesOn).utc().toString() : '';
  var params = {
    type: type,
    roleHandle: roleHandle,
    hash: values.hash,
    endpoint: values.endpoint,
    label: values.name,
    description: values.description,
    handle: values.handle,
    timepoint: values.timepoint,
    isOpen: values.open,
    opensAt: opensAt,
    closesAt: closesAt,
    respondentsFromDcwId: values.respondentConfig === 'previous' ? values.respondentSelection : null,
    settings: _objectSpread(_objectSpread({
      respondentConfig: values.respondentConfig,
      respondentSelection: values.respondentSelection
    }, settings), {}, {
      allowRetake: values.allowRetake,
      autoLogout: values.autoLogout,
      autoLogoutTime: values.autoLogoutTime,
      anonAutoLogoutMessage: values.anonAutoLogoutMessage,
      branchedCompletionConfig: values.branchedCompletionConfig || {},
      chainEmailFromPawn: values.chainEmailFromPawn,
      chainPhoneFromPawn: values.chainPhoneFromPawn,
      chainLanguageFromPawn: values.chainLanguageFromPawn,
      closeOnTarget: values.closeOnTarget,
      closedMessage: values.closedMessage,
      closedRoster: values.closedRoster,
      completedMessage: values.completedMessage,
      completionMessage: values.completionMessage,
      completionUrl: values.completionUrl,
      individualPasscode: values.individualPasscode,
      isAssignmentPlanEligible: values.isAssignmentPlanEligible,
      isRepeated: values.isRepeated,
      knownAutoLogoutMessage: values.knownAutoLogoutMessage,
      logoutOnCompletion: values.logoutOnCompletion,
      metricToRespondentPropertyMappings: values.metricToRespondentPropertyMappings,
      options: values.options,
      otherAllowedRoles: values.otherAllowedRoles,
      passcodeAssistant: values.passcodeAssistant,
      passcodeBackground: values.passcodeBackground,
      passcodeBackgroundColor: values.passcodeBackgroundColor,
      passcodeBackgroundUpload: values.passcodeBackgroundUpload,
      passcodeCompletionButtonText: values.passcodeCompletionButtonText,
      passcodeLabel: values.passcodeLabel,
      postCompletionAction: values.postCompletionAction,
      recaptcha: values.recaptcha,
      repeatInterval: values.repeatInterval,
      requireLogin: values.requireLogin,
      requirePass: values.requirePass,
      showReviewButtonOnCompletion: values.showReviewButtonOnCompletion,
      targetResponses: values.targetResponses,
      useEndpoint: values.useEndpoint
    })
  };
  return params;
};
var FormIndex = function FormIndex(props) {
  var assignment = props.assignment,
    closeModal = props.closeModal;
  var dispatch = (0, _reactRedux.useDispatch)();
  var allSurveys = (0, _react.useMemo)(function () {
    var result = [];
    var _iterator = _createForOfIteratorHelper(assignment.surveylistList),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _result;
        var sl = _step.value;
        (_result = result).push.apply(_result, _toConsumableArray(sl.surveyList));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    result = (0, _sortBy2["default"])((0, _uniqBy2["default"])(result, 'surveyHandle'), 'position');
    var languages = assignment.settings.languages;
    result.forEach(function (survey) {
      survey.readyForDeploy = languages.every(function (lang) {
        return survey.flowList.find(function (flow) {
          return flow.language === lang;
        });
      });
    });
    return result;
  }, [assignment]);
  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(values) {
      var _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return dispatch((0, _admin.createWave)(assignment.assignmentId, getParams(values)));
          case 1:
            (0, _cccisdNotification["default"])('Data Collection Wave successfully created');
            closeModal();
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            (0, _cccisdNotification["default"])({
              type: 'danger',
              duration: 0,
              data: _t,
              message: 'Could not save Data Collection Wave'
            });
            return _context.a(2, Promise.reject(_t));
          case 3:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2]]);
    }));
    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var deployHash = _randomstring["default"].generate({
    length: 7,
    charset: 'alphanumeric',
    capitalization: 'lowercase'
  });
  return /*#__PURE__*/_react["default"].createElement(_form["default"], {
    assignmentId: assignment.assignmentId,
    onSubmit: onSubmit,
    isNew: true,
    initialValues: {
      allowRetake: false,
      autoLogout: true,
      autoLogoutTime: 20,
      anonAutoLogoutMessage: "<p>Inactivity Timeout</p><p>We closed your survey session after a period of inactivity.</p>\n                    <p>Sorry! <a href=\"".concat(Boilerplate.url('/d/' + deployHash), "\" target=\"_blank\" rel=\"noreferrer noopener\">Start a new session</a></p>"),
      branchedCompletionConfig: {},
      chainEmailFromPawn: '',
      chainPhoneFromPawn: '',
      chainLanguageFromPawn: '',
      closeOnTarget: false,
      closedMessage: 'This survey is no longer accepting responses.',
      closedRoster: false,
      completedMessage: 'You have already completed this survey. Thank you!',
      completionMessage: 'You have completed the survey! Thank you for your response!',
      hash: deployHash,
      individualPasscode: false,
      isAssignmentPlanEligible: false,
      isRepeated: false,
      knownAutoLogoutMessage: "<p>Inactivity Timeout</p><p>We closed your survey session after a period of inactivity. Sorry!</p>\n                        <p>You can resume your session from the link you were given, or contact your survey administrator for further assistance.</p>",
      logoutOnCompletion: false,
      metricToRespondentPropertyMappings: [],
      open: false,
      options: allSurveys.filter(function (survey) {
        return survey.readyForDeploy;
      }).map(function (survey) {
        return survey.surveyHandle;
      }),
      otherAllowedRoles: ['uberadmin', 'questprojectadmin'],
      passcodeBackground: 'solidColor',
      passcodeBackgroundColor: '#F1F0F5',
      passcodeCompletionButtonText: 'Ok',
      passcodeLabel: 'Your Passcode',
      postCompletionAction: 'message',
      recaptcha: false,
      repeatInterval: '',
      requireLogin: false,
      requirePass: false,
      respondentConfig: 'anonymous',
      showReviewButtonOnCompletion: false,
      useEndpoint: false
    },
    surveyList: allSurveys
  });
};
FormIndex.propTypes = {
  assignment: _propTypes["default"].object,
  closeModal: _propTypes["default"].func
};
var _default = exports["default"] = FormIndex;